
export default {
  data() {
    return {
      isMounted: false,
      addressInfo: null,
      countryName: "",
    };
  },

  computed: {
    totalArticles() {
      if (!this.isMounted) return;
      else {
        let sum = 0;

        if (
          this.$refs.cartItems &&
          this.$refs.cartItems.cartItems &&
          this.$refs.cartItems.cartItems.length
        ) {
          this.$refs.cartItems.cartItems.forEach(
            (product) => (sum = sum + product.qty)
          );
        }
        return sum;
      }
    },
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    getAddressInfo(form) {
      this.addressInfo = form;
    },

    getSelectedCountryName(name) {
      this.countryName = name;
    },
  },
};
